import { schema } from 'normalizr';

const CONTACT_SCHEMA = new schema.Entity('contacts', {}, { idAttribute: '@id' });

export default {
  'http://schema.org/Person': CONTACT_SCHEMA
};
